import { Navigate, useLocation } from "react-router-dom";

export function DefaultAppPage() {
  const location = useLocation();
  return <Navigate to={{ ...location, pathname: "layers" }} />;
}
